import { Button, BUTTON_TYPE, Cart } from '@bepure/tarkin';
import { RegularProduct } from '@bepure/tarkin/dist/utils/cart';
import React, { useState } from 'react';
import { CartProduct } from './AddToCartBtn';


interface Props {
    sku: string;
    product: CartProduct;
    otherClasses?: string;
    buttonType?: BUTTON_TYPE;
    id?: string;
    textOverride?: string;
}


const BuyNowBtn = (props: Props) => {

    const [buyNowText, setBuyNowButtonText] = useState('Buy Now')

    const addToCart = async () => {
        const cart = Cart.getInstance();
        const cartItems = cart.getItems();
        const product: RegularProduct = {
            name: props.product.name,
            unit_price: props.product.unit_price,
            sku: props.sku,
            imageUrl: props.product.imageUrl,
            productId: props.product.id,
            quantity: cartItems[props.product.id]?.quantity + 1 || 1,
        };
        await cart.updateItem(product);
        window.location.href = window.Obiwan.SHOPPING_CART_URL;
    }

    const buyNowClick = () => {
        setBuyNowButtonText('Heading to Cart...')
        addToCart();
    }


    return (
        <Button 
            id={props.id}
            text={props.textOverride ? props.textOverride : buyNowText}
            ariaLabel={'buy-now'}
            onClick={buyNowClick}
            otherClasses={props.otherClasses}
            button_type={props.buttonType}
        />
    )
}

export default BuyNowBtn;